import { api } from 'app/config/apiConfig';

export enum PersonalVerificationDocumentType {
  PASSPORT_MAIN = 'passport_main',
  PASSPORT_REG = 'passport_registration',
  SELFIE_WITH_PASSPORT = 'selfie_with_passport',
}

export enum BusinessVerificationDocumentType {
  COMPANY_REG_CERT = 'company_registration_cert',
}

export enum TerminationDocumentType {
  MOVE_OUT_PHOTO = 'move_out_photo',
}

export type VerificationDocumentType = PersonalVerificationDocumentType | BusinessVerificationDocumentType | TerminationDocumentType;

export enum VerificationFileStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface VerificationDocument {
  verificationPhotoId: string;
  name: string;
  documentType: VerificationDocumentType;
  fileStatus: VerificationFileStatus;
  note: string | null;
  createdAt: string;
  updatedAt: string;
  base64?: string;
  fileUrl?: string;
}

interface UploadArgs {
  userId: string;
  files: File[];
  documentTypes: VerificationDocumentType[];
}

export const getUserVerificationDocumentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserVerificationDocuments: builder.query<VerificationDocument[], { userId: string }>({
      query: ({ userId }) => ({
        url: `/users/${userId}/verification-documents`,
        params: { latestOnly: true },
      }),
      providesTags: ['VerificationDocuments'],
    }),
    uploadVerificationDocument: builder.mutation<VerificationDocument, UploadArgs>({
      query: ({ userId, files, documentTypes }) => {
        const formData = new FormData();

        files.forEach((file) => {
          formData.append('files', file);
        });

        documentTypes.forEach((type) => {
          formData.append('documentTypes', type);
        });

        return {
          url: `/users/${userId}/verification-request`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['VerificationDocuments'],
    }),
  }),
});

export const { useGetUserVerificationDocumentsQuery, useUploadVerificationDocumentMutation } = getUserVerificationDocumentsApi;
